import { render, staticRenderFns } from "./BreakageInfo.vue?vue&type=template&id=8795878c&scoped=true&"
import script from "./BreakageInfo.vue?vue&type=script&lang=js&"
export * from "./BreakageInfo.vue?vue&type=script&lang=js&"
import style0 from "./BreakageInfo.vue?vue&type=style&index=0&id=8795878c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8795878c",
  null
  
)

export default component.exports